define('lq/events/actions/pdfMergeCommand_v2',[
    'lq/events/actions/eventAction',
    'lq'
], function (EventAction, lq) {
    'use strict';

    var PdfMergeCommand_v2 = function(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    };

    EventAction.extend(PdfMergeCommand_v2, EventAction);

    PdfMergeCommand_v2.typeName = 'PdfMergeCommand_v2';

    PdfMergeCommand_v2.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PdfMergeCommand_v2.prototype.createEventActionRequest = function () {
        var self = this;

        return {
            eventActionType: 'PdfMerge',
            command: self.eventData.command
        };
    };

    PdfMergeCommand_v2.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty) {
            this.handleExecutionTrailDirty(continuation);
        } else {
            if (eventActionResponse.download) {
                var url = lq.getTenantUrl(
                    'PdfMerge/?actionId=' + eventActionResponse.actionId +
                    '&pdfMergeId=' + eventActionResponse.pdfMergeId +
                    '&openInBrowser=' + (eventActionResponse.downloadBehaviour !== 'download') +
                    '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters() || {})));

                if (eventActionResponse.downloadBehaviour === 'openInCurrentTab' || eventActionResponse.downloadBehaviour === 'download') {
                    window.location = url;
                } else {
                    window.open(url + '#toolbar=1');
                }
            }
            continuation();
        }
    };

    return PdfMergeCommand_v2;
});
